import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import type { Option, SelectProps } from 'components/common';
import { AdAccountSelect as CommonAdAccountSelect } from 'components/common';
import { useAccounts } from '../api/getAccounts';
import type { FC } from 'react';
import type { ResultEntry } from 'types/shared';
import { useEffect } from 'react';
import datadogActions from 'lib/datadog';

type AdAccountSelectProps = Pick<SelectProps, 'handleChange'>

export const AdAccountSelect = ({ handleChange }: AdAccountSelectProps) => {
  const { watch } = useFormContext();
  const app = watch('app');

  const { data, isLoading, isError, error } = useAccounts<Option[]>({
    params: { app, platform: 'WEB' },
    config: {
      enabled: !!app,
      select: (data) =>
        data.map((item) => ({
          value: item.account_id,
          label: item.name,
        })),
    },
  });

  useEffect(() => {
    if (!isError || !error) {
      return;
    }

    datadogActions.trackDatadogError(error as Error, {
      source: 'tiktok_ad_account_select_query',
      app: String(app ?? ''),
      platform: 'WEB',
    });
  }, [isError, error, app]);
  return (
    <CommonAdAccountSelect
      name="accountId"
      inputLabel="Ad Account"
      options={data}
      isLoading={isLoading}
      onChange={handleChange}
    />
  );
};

export const JobResultTable: FC<{ rows?: ResultEntry[] }> = ({ rows }) => {
  return (
    <TableContainer sx={{ width: '100%' }}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ minWidth: 220 }}>Account Ad ID</TableCell>
            <TableCell align="center" sx={{ minWidth: 120 }}>
              AdGroup
            </TableCell>
            <TableCell align="center">Creative</TableCell>
            <TableCell align="center" sx={{ minWidth: 120 }}>
              Result
            </TableCell>
            <TableCell align="center" sx={{ minWidth: 120 }}>
              Ad ID
            </TableCell>
            <TableCell align="center">Message</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map((row, i) => (
            <TableRow
              key={`${i}:${row.name}`}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                <Typography
                  sx={{
                    fontSize: 14,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-all',
                  }}
                >
                  {row.advertiser_id}
                </Typography>
              </TableCell>
              <TableCell align="left">
                {' '}
                <Typography
                  sx={{
                    fontSize: 14,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-all',
                  }}
                >
                  {row.adgroup_name}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography
                  sx={{
                    fontSize: 14,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-all',
                  }}
                >
                  {row.creative_name}
                </Typography>
              </TableCell>
              <TableCell align="center">
                {row.is_successful ? '✅' : '❌'}
              </TableCell>
              <TableCell align="left">
                <Typography
                  sx={{
                    fontSize: 14,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-all',
                  }}
                >
                  {row.ad_id}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography
                  sx={{
                    fontSize: 14,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-all',
                  }}
                >
                  {row.message}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
